import { styled as u, Snackbar as p, Alert as d } from "@mui/material";
import { DEFAULT_SNACKBAR_SHOW_DURATION as A } from "../../../constants/layout.js";
import { useMessageContext as S } from "../../../contexts/share/MessageContext.js";
import * as a from "ramda";
import { forwardRef as N, useState as i, useCallback as k, useEffect as C } from "react";
import { jsx as s } from "react/jsx-runtime";
const b = u(p)`
  bottom: unset;
  left: 50%;
  right: unset;
  top: 8px;
  transform: translateX(-50%);
  width: unset;
`, g = N(function(e, t) {
  return /* @__PURE__ */ s(d, {
    ref: t,
    ...e
  });
}), D = (r) => {
  const {
    className: e
  } = r, {
    snackInfo: t,
    setSnackInfo: o
  } = S(), [l, c] = i(""), [f, m] = i("success"), n = k(() => {
    o(null);
  }, [o]);
  return C(() => {
    a.isNotNil(t) && (c(t.message), m(t.serverity));
  }, [t]), /* @__PURE__ */ s(b, {
    className: e,
    open: a.isNotNil(t),
    autoHideDuration: A,
    onClose: n,
    children: /* @__PURE__ */ s(g, {
      onClose: n,
      variant: "filled",
      severity: f,
      children: l
    })
  });
};
export {
  D as default
};
//# sourceMappingURL=Snackbar.js.map
